import { AlertCircle, RefreshCw } from "lucide-react";

import { Button } from "@/common/ui/button";

import { MetricsSummaryCards } from "./MetricsSummaryCards";
import { TimeRangeSelector } from "./TimeRangeSelector";
import { TopUsersTable } from "./TopUsersTable";
import { useUsageMetrics } from "./use-usage-metrics";

export function UsageMetricsPage(): React.ReactElement {
  const { metrics, isLoading, error, timeRange, setTimeRange, refresh } = useUsageMetrics();

  return (
    <div data-testid="usage-metrics-page" className="space-y-6">
      <div className="flex items-center justify-end gap-3">
        <TimeRangeSelector value={timeRange} onChange={setTimeRange} />
        <Button
          data-testid="refresh-metrics"
          variant="outline"
          size="sm"
          onClick={refresh}
          disabled={isLoading}
        >
          <RefreshCw className={`mr-1 h-4 w-4 ${isLoading ? "animate-spin" : ""}`} />
          Refresh
        </Button>
      </div>

      {error !== null && (
        <div
          data-testid="metrics-error"
          className="flex items-center gap-2 rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive"
        >
          <AlertCircle className="h-4 w-4 shrink-0" />
          <span>{error}</span>
          <Button
            data-testid="metrics-retry"
            variant="outline"
            size="sm"
            className="ml-auto"
            onClick={refresh}
          >
            Retry
          </Button>
        </div>
      )}

      <MetricsSummaryCards summary={metrics?.summary ?? null} isLoading={isLoading} />

      <TopUsersTable users={metrics?.top_users ?? []} isLoading={isLoading} />

      {metrics !== null && (
        <p data-testid="metrics-queried-at" className="text-xs text-muted-foreground">
          Last queried: {new Date(metrics.queried_at).toLocaleString()}
        </p>
      )}
    </div>
  );
}
